<!--
 * @Description:
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-19 09:17:50
 * @LastEditors: lau
 * @LastEditTime: 2022-08-19 10:00:57
-->
<!-- 查询线上月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {

            },
            responseCode: {

            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询月票访客授权",
                t_url: this.commonUrls.test + "getMonthTicketAuthorizeVisitor",
                p_url: this.commonUrls.prod + "getMonthTicketAuthorizeVisitor",
                precondition: "无",
                fitSystem: "云停车场，传统停车场（线上开通的月票）",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketBillId', info2: '是', info3: 'Long', info4: '月票订单ID' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前总数' },
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' },

					   ]
                },
                {
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'authorizeId', info2: '是', info3: 'Long', info4: '授权记录id' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号码' },
                        { info1: 'createTime', info2: '是', info3: 'String', info4: '创建时间yyyyMMddHHmmss' },
                        { info1: 'inviteTime', info2: '是', info3: 'String', info4: '邀请时间yyyyMMddHHmmss' },
                        { info1: 'monthTicketBillId', info2: '是', info3: 'Long', info4: '月票订单ID' },
                        { info1: 'status', info2: '是', info3: 'Integer', info4: '状态，0=正常，1=已删除，2=已过期' },
                        { info1: 'validFrom', info2: '是', info3: 'String', info4: '有效开始时间yyyyMMddHHmmss' },
                        { info1: 'validTo', info2: '是', info3: 'String', info4: '有效结束时间yyyyMMddHHmmss' },
                        { info1: 'authTimes', info2: '否', info3: 'String', info4: '授权次数，当此请求访问的是新系统时，此值必传' },

					   ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getMonthTicketAuthorizeVisitor.vue